import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Container, Card, Badge } from "../components/ui";
import ReadMore from "../components/common/ReadMore";
import { Navigate, Link, useParams } from "react-router-dom";
import FavoritesCard from "../components/common/favorite-card";
import Post from "../components/common/post";
import { DotLoader } from "react-spinners";
import { withRouter } from "../hooks/withRouter";
import {
  getMixedPostsForPublisher,
  getMemberAlerts,
  getEducationalPosts,
  getPublishers,
} from "../api";

class Analyst extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      alerts: [],
      educationalPosts: [],
      loading: false,
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    window.scrollTo(0, 0);
    const publishers = await getPublishers();
    const profile = publishers.data.filter((p) => {
      return p.slug === this.props.match?.params?.id;
    })[0];
    let user = localStorage.getItem("user");
    let posts;
    let alerts;
    if (user) {
      posts = await getMixedPostsForPublisher(profile.id, 3, 0);
      alerts = await getMemberAlerts(profile.id, "*", 3, 0);
    } else {
      posts = await getMixedPostsForPublisher(profile.id, 3, 0);
      alerts = {
        data: [],
      };
    }
    const initialFilter = {
      authorIds: [profile.id],
      tagIds: [],
      educationOnly: true,
      searchString: "",
    };
    let educationalPosts = await getEducationalPosts(initialFilter, 3, 0);
    this.setState({
      posts: posts.data.items,
      alerts: alerts.data.items,
      educationalPosts: educationalPosts.data.items,
      user: user,
      profile: profile,
      loading: false,
    });
  };

  seeAllEducation = (profile) => {
    this.props.navigate("/education", {
      state: {
        analyst: profile.id,
      },
    });
  };

  seeAllPosts = (profile) => {
    this.props.navigate("/blogs/premium", {
      state: {
        analyst: profile.id,
      },
    });
  };

  seeAllAlerts = (profile) => {
    this.props.navigate("/alerts", {
      state: {
        analyst: profile.id,
      },
    });
  };

  render() {
    const { profile, user } = this.state;
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <React.Fragment>
        <Card className="analyst-card">
          <Container>
            <Row>
              <Col lg="7">
                <Row>
                  <Col lg="1" className="photo-top">
                    <div className="mx-auto">
                      <img
                        className="rounded-circle"
                        src={profile && profile.avatar.medium}
                        alt={profile && profile.name}
                        width="80"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <h4>{profile && profile.name}</h4>
                    <Badge
                      pill
                      className={`card-post__category badge-content-tag`}
                    >
                      Analyst
                    </Badge>
                  </Col>
                  {profile && profile.bio !== null && (
                    <Col lg="12">
                      <div className="analyst-text">
                        <ReadMore
                          text={profile && profile.bio}
                          min={330}
                          ideal={340}
                          max={350}
                          readMoreText="Read more..."
                        />
                      </div>
                    </Col>
                  )}
                </Row>
              </Col>

              <Col lg="5">
                <div className="video">
                  {profile &&
                    profile.featuredVideo &&
                    profile.featuredVideo.mediaId && (
                      <div
                        className={
                          "wistia_embed wistia_async_" +
                          profile.featuredVideo.mediaId
                        }
                      ></div>
                    )}
                </div>
              </Col>
            </Row>
          </Container>
        </Card>
        <Container>
          <Row>
            <Col lg="6" md="12">
              <FavoritesCard
                loggedIn={!user}
                type="posts"
                seeAll={() => this.seeAllPosts(profile)}
                seeAllVisible={true}
                posts={this.state.posts}
              />
            </Col>
            <Col lg="6" md="12">
              <FavoritesCard
                loggedIn={!user}
                type="alerts"
                seeAll={() => this.seeAllAlerts(profile)}
                seeAllVisible={true}
                posts={this.state.alerts}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Card className="education-posts">
            <Row>
              <Col lg="12">
                <span className="title">
                  Education
                  <div className="see-all">
                    <span
                      className="see-all-text"
                      onClick={() => this.seeAllEducation(profile)}
                    >
                      See All
                    </span>
                    <span
                      className="see-all-btn"
                      onClick={() => this.seeAllEducation(profile)}
                    >
                      +
                    </span>
                  </div>
                </span>
              </Col>
            </Row>
            <div
              style={{
                margin: window.screen.width > 768 ? "0% 25%" : "0% 5%",
                borderLeft: "1px solid #ebebeb",
                borderRight: "1px solid #ebebeb",
                padding: window.screen.width > 768 ? "0px 55px" : "0px 0px",
              }}
              id={"post-wrapper"}
            >
              {this.state.educationalPosts.map((post, idx) => (
                <>
                  <Link
                    to={`/analyst/${post.author.slug}`}
                    className="card-post__author-avatar card-post__author-avatar--small"
                    style={{
                      backgroundImage: `url('${post.author.avatar.small}')`,
                      zIndex: 10,
                      width: window.screen.width > 768 ? 65 : 40,
                      height: window.screen.width > 768 ? 65 : 40,
                      position: "absolute",
                      marginLeft: window.screen.width > 768 ? "-90px" : "-19px",
                    }}
                  ></Link>
                  <Post key={idx} col={"12"} post={post} />
                </>
              ))}
            </div>
          </Card>
        </Container>
      </React.Fragment>
    );
  }
}

Analyst.propTypes = {
  userDetails: PropTypes.object,
};

export default withRouter(Analyst);
